<template>
  <v-app>
    <v-container fluid fill-height class="darkbg">
      <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="6"
            md="4"
            align="center"
          >
            <img :src="images.logo" width="150" @click="$router.push({name: 'Home'});"/>
            <v-card
              class="elevation-12"
              light
            >
              <v-card-title class="pb-0">
                Login to Customer Portal
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout
                  row
                  fill-height
                  justify-center
                  align-center
                  v-if="loading"
                >
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </v-layout>

                <v-form
                  v-else
                  ref="form"
                  v-model="valid"
                >
                  <v-text-field
                    v-model="username"
                    :rules="nameRules"
                    prepend-inner-icon="mdi-account"
                    label="Username"
                    color="primary"
                    autocomplete="username"
                    autofocus
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :rules="passwordRules"
                    color="primary"
                    autocomplete="current-password"
                    @keyup.enter.native="validate"
                    required
                  ></v-text-field>

                  <v-checkbox
                    v-model="remember_cbx"
                    label="Remember me ?"
                    color="primary"
                  ></v-checkbox>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
                <v-btn color="grey" text to='/reset'>
                  Forgot password?
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="!valid"
                  color="primary"
                  @click="validate"
                  >
                  <v-icon left>mdi-lock</v-icon>
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-spacer></v-spacer>
            <br/>
            <v-card
              class="elevation-12"
              color="primary"
            >
              <v-btn text block to='/signup'>
                <v-icon small class="pr-2">mdi-account-plus</v-icon> New user - Signup
              </v-btn>
            </v-card>
            <v-btn class="text-left mt-4" text to="/"><v-icon left dark>mdi-arrow-left</v-icon>Back to Home</v-btn>
          </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      <span v-html="snackText"></span>
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-footer>
     <v-spacer></v-spacer>
    <div class="caption">&copy; {{ new Date().getFullYear() }} - Patrowl.io</div>
   </v-footer>
  </v-app>
</template>

<script>


export default {
  name: 'AppLogin',
  data: () => ({
    valid: true,
    loading: false,
    captcha_token: '',
    username: '',
    password: '',
    remember_cbx: true,
    showPassword: false,
    nameRules: [
      v => !!v || 'Username is required',
    ],
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length > 8) || "The password must be longer than 8 characters"
    ],
    images: {
      // logo: require('@/assets/img/logo-owl-text-large-white.png'),
      logo: require('@/assets/img/logo-patrowl-black.png'),
    },
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  mounted() {
    this.recaptcha();
  },
  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded()
       this.captcha_token = await this.$recaptcha('login');
     },
    validate () {
      if (this.valid && this.captcha_token != '') {
        let formdata = {
          'username': this.username,
          'password': this.password,
          'g-recaptcha-response': this.captcha_token,
        };

        this.loading = true;
        this.$store.commit("removeToken");
        this.$api.post(this.$store.state.endpoints.obtainJWT, formdata).then(res => {
          this.$store.commit('updateToken', res.data.access);
          localStorage.setItem('username', this.username);
          this.$router.push({name: 'PrivateHome'});
        }).catch(e => {
          if (e.response.status == 401 && e.response.data.detail == "No active account found with the given credentials") {
            this.snack = true;
            this.snackColor = 'error';
            this.snackText = 'Activate your account before login. Check your mails !';
          }
          this.$store.commit("removeToken");
          this.loading = false;
        });

      }
    },
  },
}
</script>
<style scoped>
  h1 {
    font-size: 150px;
    line-height: 150px;
    font-weight: 700;
    color: #252932;
    text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
  }
</style>
